import React from "react";

const handleAutodeposit = (props) => {
  const options = [
    {
      text: 'Qu’est-ce que la fonction Demander des fonds de Virement INTERAC?',
      handler: props.actionProvider.handleAutodeposit1,
      id: 1,
    },
    {
      text: 'La fonction Dépôt automatique de Virement INTERAC est-elle sécuritaire?',
      handler: props.actionProvider.handleAutodeposit2,
      id: 2
    },
    {
      text: 'Comment puis-je m’inscrire à la fonction Dépôt automatique de Virement INTERAC?',
      handler: props.actionProvider.handleAutodeposit3,
      id: 3
    },
    {
      text: 'Je ne vois pas comment je peux m’inscrire à la fonction Dépôt automatique de Virement INTERAC auprès de ma banque.',
      handler: props.actionProvider.handleAutodeposit4,
      id: 4
    },
    {
      text: 'Je n’ai pas reçu le courriel de vérification de l’inscription à la fonction Dépôt automatique de Virement INTERAC.',
      handler: props.actionProvider.handleAutodeposit5,
      id: 5
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container autodeposit-products'>{optionsMarkup}</div>;
};

export default handleAutodeposit;